/**
 * 全球国家/地区电话区号数据
 * 常用国家置顶，其余按英文名称字母排序
 */
import { CountryCode } from '../../types';

export const COUNTRY_CODES: CountryCode[] = [
  // ===== 常用国家（置顶）=====
  { code: 'CN', dialCode: '+86', nameZh: '中国', nameEn: 'China' },
  { code: 'US', dialCode: '+1', nameZh: '美国', nameEn: 'United States' },
  { code: 'GB', dialCode: '+44', nameZh: '英国', nameEn: 'United Kingdom' },
  { code: 'JP', dialCode: '+81', nameZh: '日本', nameEn: 'Japan' },
  { code: 'KR', dialCode: '+82', nameZh: '韩国', nameEn: 'South Korea' },
  { code: 'SG', dialCode: '+65', nameZh: '新加坡', nameEn: 'Singapore' },
  { code: 'AU', dialCode: '+61', nameZh: '澳大利亚', nameEn: 'Australia' },
  { code: 'CA', dialCode: '+1', nameZh: '加拿大', nameEn: 'Canada' },
  { code: 'DE', dialCode: '+49', nameZh: '德国', nameEn: 'Germany' },
  { code: 'FR', dialCode: '+33', nameZh: '法国', nameEn: 'France' },
  { code: 'HK', dialCode: '+852', nameZh: '中国香港', nameEn: 'Hong Kong' },
  { code: 'TW', dialCode: '+886', nameZh: '中国台湾', nameEn: 'Taiwan' },
  { code: 'MY', dialCode: '+60', nameZh: '马来西亚', nameEn: 'Malaysia' },
  { code: 'TH', dialCode: '+66', nameZh: '泰国', nameEn: 'Thailand' },
  { code: 'VN', dialCode: '+84', nameZh: '越南', nameEn: 'Vietnam' },
  { code: 'IN', dialCode: '+91', nameZh: '印度', nameEn: 'India' },

  // ===== 其他国家（按英文名称字母排序）=====
  { code: 'AF', dialCode: '+93', nameZh: '阿富汗', nameEn: 'Afghanistan' },
  { code: 'AL', dialCode: '+355', nameZh: '阿尔巴尼亚', nameEn: 'Albania' },
  { code: 'DZ', dialCode: '+213', nameZh: '阿尔及利亚', nameEn: 'Algeria' },
  { code: 'AD', dialCode: '+376', nameZh: '安道尔', nameEn: 'Andorra' },
  { code: 'AO', dialCode: '+244', nameZh: '安哥拉', nameEn: 'Angola' },
  { code: 'AG', dialCode: '+1268', nameZh: '安提瓜和巴布达', nameEn: 'Antigua and Barbuda' },
  { code: 'AR', dialCode: '+54', nameZh: '阿根廷', nameEn: 'Argentina' },
  { code: 'AM', dialCode: '+374', nameZh: '亚美尼亚', nameEn: 'Armenia' },
  { code: 'AT', dialCode: '+43', nameZh: '奥地利', nameEn: 'Austria' },
  { code: 'AZ', dialCode: '+994', nameZh: '阿塞拜疆', nameEn: 'Azerbaijan' },
  { code: 'BS', dialCode: '+1242', nameZh: '巴哈马', nameEn: 'Bahamas' },
  { code: 'BH', dialCode: '+973', nameZh: '巴林', nameEn: 'Bahrain' },
  { code: 'BD', dialCode: '+880', nameZh: '孟加拉国', nameEn: 'Bangladesh' },
  { code: 'BB', dialCode: '+1246', nameZh: '巴巴多斯', nameEn: 'Barbados' },
  { code: 'BY', dialCode: '+375', nameZh: '白俄罗斯', nameEn: 'Belarus' },
  { code: 'BE', dialCode: '+32', nameZh: '比利时', nameEn: 'Belgium' },
  { code: 'BZ', dialCode: '+501', nameZh: '伯利兹', nameEn: 'Belize' },
  { code: 'BJ', dialCode: '+229', nameZh: '贝宁', nameEn: 'Benin' },
  { code: 'BT', dialCode: '+975', nameZh: '不丹', nameEn: 'Bhutan' },
  { code: 'BO', dialCode: '+591', nameZh: '玻利维亚', nameEn: 'Bolivia' },
  { code: 'BA', dialCode: '+387', nameZh: '波黑', nameEn: 'Bosnia and Herzegovina' },
  { code: 'BW', dialCode: '+267', nameZh: '博茨瓦纳', nameEn: 'Botswana' },
  { code: 'BR', dialCode: '+55', nameZh: '巴西', nameEn: 'Brazil' },
  { code: 'BN', dialCode: '+673', nameZh: '文莱', nameEn: 'Brunei' },
  { code: 'BG', dialCode: '+359', nameZh: '保加利亚', nameEn: 'Bulgaria' },
  { code: 'BF', dialCode: '+226', nameZh: '布基纳法索', nameEn: 'Burkina Faso' },
  { code: 'BI', dialCode: '+257', nameZh: '布隆迪', nameEn: 'Burundi' },
  { code: 'KH', dialCode: '+855', nameZh: '柬埔寨', nameEn: 'Cambodia' },
  { code: 'CM', dialCode: '+237', nameZh: '喀麦隆', nameEn: 'Cameroon' },
  { code: 'CV', dialCode: '+238', nameZh: '佛得角', nameEn: 'Cape Verde' },
  { code: 'CF', dialCode: '+236', nameZh: '中非', nameEn: 'Central African Republic' },
  { code: 'TD', dialCode: '+235', nameZh: '乍得', nameEn: 'Chad' },
  { code: 'CL', dialCode: '+56', nameZh: '智利', nameEn: 'Chile' },
  { code: 'CO', dialCode: '+57', nameZh: '哥伦比亚', nameEn: 'Colombia' },
  { code: 'KM', dialCode: '+269', nameZh: '科摩罗', nameEn: 'Comoros' },
  { code: 'CG', dialCode: '+242', nameZh: '刚果（布）', nameEn: 'Congo' },
  { code: 'CD', dialCode: '+243', nameZh: '刚果（金）', nameEn: 'Congo (DRC)' },
  { code: 'CR', dialCode: '+506', nameZh: '哥斯达黎加', nameEn: 'Costa Rica' },
  { code: 'HR', dialCode: '+385', nameZh: '克罗地亚', nameEn: 'Croatia' },
  { code: 'CU', dialCode: '+53', nameZh: '古巴', nameEn: 'Cuba' },
  { code: 'CY', dialCode: '+357', nameZh: '塞浦路斯', nameEn: 'Cyprus' },
  { code: 'CZ', dialCode: '+420', nameZh: '捷克', nameEn: 'Czech Republic' },
  { code: 'DK', dialCode: '+45', nameZh: '丹麦', nameEn: 'Denmark' },
  { code: 'DJ', dialCode: '+253', nameZh: '吉布提', nameEn: 'Djibouti' },
  { code: 'DM', dialCode: '+1767', nameZh: '多米尼克', nameEn: 'Dominica' },
  { code: 'DO', dialCode: '+1809', nameZh: '多米尼加', nameEn: 'Dominican Republic' },
  { code: 'EC', dialCode: '+593', nameZh: '厄瓜多尔', nameEn: 'Ecuador' },
  { code: 'EG', dialCode: '+20', nameZh: '埃及', nameEn: 'Egypt' },
  { code: 'SV', dialCode: '+503', nameZh: '萨尔瓦多', nameEn: 'El Salvador' },
  { code: 'GQ', dialCode: '+240', nameZh: '赤道几内亚', nameEn: 'Equatorial Guinea' },
  { code: 'ER', dialCode: '+291', nameZh: '厄立特里亚', nameEn: 'Eritrea' },
  { code: 'EE', dialCode: '+372', nameZh: '爱沙尼亚', nameEn: 'Estonia' },
  { code: 'SZ', dialCode: '+268', nameZh: '斯威士兰', nameEn: 'Eswatini' },
  { code: 'ET', dialCode: '+251', nameZh: '埃塞俄比亚', nameEn: 'Ethiopia' },
  { code: 'FJ', dialCode: '+679', nameZh: '斐济', nameEn: 'Fiji' },
  { code: 'FI', dialCode: '+358', nameZh: '芬兰', nameEn: 'Finland' },
  { code: 'GA', dialCode: '+241', nameZh: '加蓬', nameEn: 'Gabon' },
  { code: 'GM', dialCode: '+220', nameZh: '冈比亚', nameEn: 'Gambia' },
  { code: 'GE', dialCode: '+995', nameZh: '格鲁吉亚', nameEn: 'Georgia' },
  { code: 'GH', dialCode: '+233', nameZh: '加纳', nameEn: 'Ghana' },
  { code: 'GR', dialCode: '+30', nameZh: '希腊', nameEn: 'Greece' },
  { code: 'GD', dialCode: '+1473', nameZh: '格林纳达', nameEn: 'Grenada' },
  { code: 'GT', dialCode: '+502', nameZh: '危地马拉', nameEn: 'Guatemala' },
  { code: 'GN', dialCode: '+224', nameZh: '几内亚', nameEn: 'Guinea' },
  { code: 'GW', dialCode: '+245', nameZh: '几内亚比绍', nameEn: 'Guinea-Bissau' },
  { code: 'GY', dialCode: '+592', nameZh: '圭亚那', nameEn: 'Guyana' },
  { code: 'HT', dialCode: '+509', nameZh: '海地', nameEn: 'Haiti' },
  { code: 'HN', dialCode: '+504', nameZh: '洪都拉斯', nameEn: 'Honduras' },
  { code: 'HU', dialCode: '+36', nameZh: '匈牙利', nameEn: 'Hungary' },
  { code: 'IS', dialCode: '+354', nameZh: '冰岛', nameEn: 'Iceland' },
  { code: 'ID', dialCode: '+62', nameZh: '印度尼西亚', nameEn: 'Indonesia' },
  { code: 'IR', dialCode: '+98', nameZh: '伊朗', nameEn: 'Iran' },
  { code: 'IQ', dialCode: '+964', nameZh: '伊拉克', nameEn: 'Iraq' },
  { code: 'IE', dialCode: '+353', nameZh: '爱尔兰', nameEn: 'Ireland' },
  { code: 'IL', dialCode: '+972', nameZh: '以色列', nameEn: 'Israel' },
  { code: 'IT', dialCode: '+39', nameZh: '意大利', nameEn: 'Italy' },
  { code: 'CI', dialCode: '+225', nameZh: '科特迪瓦', nameEn: 'Ivory Coast' },
  { code: 'JM', dialCode: '+1876', nameZh: '牙买加', nameEn: 'Jamaica' },
  { code: 'JO', dialCode: '+962', nameZh: '约旦', nameEn: 'Jordan' },
  { code: 'KZ', dialCode: '+7', nameZh: '哈萨克斯坦', nameEn: 'Kazakhstan' },
  { code: 'KE', dialCode: '+254', nameZh: '肯尼亚', nameEn: 'Kenya' },
  { code: 'KI', dialCode: '+686', nameZh: '基里巴斯', nameEn: 'Kiribati' },
  { code: 'KW', dialCode: '+965', nameZh: '科威特', nameEn: 'Kuwait' },
  { code: 'KG', dialCode: '+996', nameZh: '吉尔吉斯斯坦', nameEn: 'Kyrgyzstan' },
  { code: 'LA', dialCode: '+856', nameZh: '老挝', nameEn: 'Laos' },
  { code: 'LV', dialCode: '+371', nameZh: '拉脱维亚', nameEn: 'Latvia' },
  { code: 'LB', dialCode: '+961', nameZh: '黎巴嫩', nameEn: 'Lebanon' },
  { code: 'LS', dialCode: '+266', nameZh: '莱索托', nameEn: 'Lesotho' },
  { code: 'LR', dialCode: '+231', nameZh: '利比里亚', nameEn: 'Liberia' },
  { code: 'LY', dialCode: '+218', nameZh: '利比亚', nameEn: 'Libya' },
  { code: 'LI', dialCode: '+423', nameZh: '列支敦士登', nameEn: 'Liechtenstein' },
  { code: 'LT', dialCode: '+370', nameZh: '立陶宛', nameEn: 'Lithuania' },
  { code: 'LU', dialCode: '+352', nameZh: '卢森堡', nameEn: 'Luxembourg' },
  { code: 'MO', dialCode: '+853', nameZh: '中国澳门', nameEn: 'Macau' },
  { code: 'MG', dialCode: '+261', nameZh: '马达加斯加', nameEn: 'Madagascar' },
  { code: 'MW', dialCode: '+265', nameZh: '马拉维', nameEn: 'Malawi' },
  { code: 'MV', dialCode: '+960', nameZh: '马尔代夫', nameEn: 'Maldives' },
  { code: 'ML', dialCode: '+223', nameZh: '马里', nameEn: 'Mali' },
  { code: 'MT', dialCode: '+356', nameZh: '马耳他', nameEn: 'Malta' },
  { code: 'MH', dialCode: '+692', nameZh: '马绍尔群岛', nameEn: 'Marshall Islands' },
  { code: 'MR', dialCode: '+222', nameZh: '毛里塔尼亚', nameEn: 'Mauritania' },
  { code: 'MU', dialCode: '+230', nameZh: '毛里求斯', nameEn: 'Mauritius' },
  { code: 'MX', dialCode: '+52', nameZh: '墨西哥', nameEn: 'Mexico' },
  { code: 'FM', dialCode: '+691', nameZh: '密克罗尼西亚', nameEn: 'Micronesia' },
  { code: 'MD', dialCode: '+373', nameZh: '摩尔多瓦', nameEn: 'Moldova' },
  { code: 'MC', dialCode: '+377', nameZh: '摩纳哥', nameEn: 'Monaco' },
  { code: 'MN', dialCode: '+976', nameZh: '蒙古', nameEn: 'Mongolia' },
  { code: 'ME', dialCode: '+382', nameZh: '黑山', nameEn: 'Montenegro' },
  { code: 'MA', dialCode: '+212', nameZh: '摩洛哥', nameEn: 'Morocco' },
  { code: 'MZ', dialCode: '+258', nameZh: '莫桑比克', nameEn: 'Mozambique' },
  { code: 'MM', dialCode: '+95', nameZh: '缅甸', nameEn: 'Myanmar' },
  { code: 'NA', dialCode: '+264', nameZh: '纳米比亚', nameEn: 'Namibia' },
  { code: 'NR', dialCode: '+674', nameZh: '瑙鲁', nameEn: 'Nauru' },
  { code: 'NP', dialCode: '+977', nameZh: '尼泊尔', nameEn: 'Nepal' },
  { code: 'NL', dialCode: '+31', nameZh: '荷兰', nameEn: 'Netherlands' },
  { code: 'NZ', dialCode: '+64', nameZh: '新西兰', nameEn: 'New Zealand' },
  { code: 'NI', dialCode: '+505', nameZh: '尼加拉瓜', nameEn: 'Nicaragua' },
  { code: 'NE', dialCode: '+227', nameZh: '尼日尔', nameEn: 'Niger' },
  { code: 'NG', dialCode: '+234', nameZh: '尼日利亚', nameEn: 'Nigeria' },
  { code: 'KP', dialCode: '+850', nameZh: '朝鲜', nameEn: 'North Korea' },
  { code: 'MK', dialCode: '+389', nameZh: '北马其顿', nameEn: 'North Macedonia' },
  { code: 'NO', dialCode: '+47', nameZh: '挪威', nameEn: 'Norway' },
  { code: 'OM', dialCode: '+968', nameZh: '阿曼', nameEn: 'Oman' },
  { code: 'PK', dialCode: '+92', nameZh: '巴基斯坦', nameEn: 'Pakistan' },
  { code: 'PW', dialCode: '+680', nameZh: '帕劳', nameEn: 'Palau' },
  { code: 'PS', dialCode: '+970', nameZh: '巴勒斯坦', nameEn: 'Palestine' },
  { code: 'PA', dialCode: '+507', nameZh: '巴拿马', nameEn: 'Panama' },
  { code: 'PG', dialCode: '+675', nameZh: '巴布亚新几内亚', nameEn: 'Papua New Guinea' },
  { code: 'PY', dialCode: '+595', nameZh: '巴拉圭', nameEn: 'Paraguay' },
  { code: 'PE', dialCode: '+51', nameZh: '秘鲁', nameEn: 'Peru' },
  { code: 'PH', dialCode: '+63', nameZh: '菲律宾', nameEn: 'Philippines' },
  { code: 'PL', dialCode: '+48', nameZh: '波兰', nameEn: 'Poland' },
  { code: 'PT', dialCode: '+351', nameZh: '葡萄牙', nameEn: 'Portugal' },
  { code: 'QA', dialCode: '+974', nameZh: '卡塔尔', nameEn: 'Qatar' },
  { code: 'RO', dialCode: '+40', nameZh: '罗马尼亚', nameEn: 'Romania' },
  { code: 'RU', dialCode: '+7', nameZh: '俄罗斯', nameEn: 'Russia' },
  { code: 'RW', dialCode: '+250', nameZh: '卢旺达', nameEn: 'Rwanda' },
  { code: 'KN', dialCode: '+1869', nameZh: '圣基茨和尼维斯', nameEn: 'Saint Kitts and Nevis' },
  { code: 'LC', dialCode: '+1758', nameZh: '圣卢西亚', nameEn: 'Saint Lucia' },
  { code: 'VC', dialCode: '+1784', nameZh: '圣文森特和格林纳丁斯', nameEn: 'Saint Vincent and the Grenadines' },
  { code: 'WS', dialCode: '+685', nameZh: '萨摩亚', nameEn: 'Samoa' },
  { code: 'SM', dialCode: '+378', nameZh: '圣马力诺', nameEn: 'San Marino' },
  { code: 'ST', dialCode: '+239', nameZh: '圣多美和普林西比', nameEn: 'Sao Tome and Principe' },
  { code: 'SA', dialCode: '+966', nameZh: '沙特阿拉伯', nameEn: 'Saudi Arabia' },
  { code: 'SN', dialCode: '+221', nameZh: '塞内加尔', nameEn: 'Senegal' },
  { code: 'RS', dialCode: '+381', nameZh: '塞尔维亚', nameEn: 'Serbia' },
  { code: 'SC', dialCode: '+248', nameZh: '塞舌尔', nameEn: 'Seychelles' },
  { code: 'SL', dialCode: '+232', nameZh: '塞拉利昂', nameEn: 'Sierra Leone' },
  { code: 'SK', dialCode: '+421', nameZh: '斯洛伐克', nameEn: 'Slovakia' },
  { code: 'SI', dialCode: '+386', nameZh: '斯洛文尼亚', nameEn: 'Slovenia' },
  { code: 'SB', dialCode: '+677', nameZh: '所罗门群岛', nameEn: 'Solomon Islands' },
  { code: 'SO', dialCode: '+252', nameZh: '索马里', nameEn: 'Somalia' },
  { code: 'ZA', dialCode: '+27', nameZh: '南非', nameEn: 'South Africa' },
  { code: 'SS', dialCode: '+211', nameZh: '南苏丹', nameEn: 'South Sudan' },
  { code: 'ES', dialCode: '+34', nameZh: '西班牙', nameEn: 'Spain' },
  { code: 'LK', dialCode: '+94', nameZh: '斯里兰卡', nameEn: 'Sri Lanka' },
  { code: 'SD', dialCode: '+249', nameZh: '苏丹', nameEn: 'Sudan' },
  { code: 'SR', dialCode: '+597', nameZh: '苏里南', nameEn: 'Suriname' },
  { code: 'SE', dialCode: '+46', nameZh: '瑞典', nameEn: 'Sweden' },
  { code: 'CH', dialCode: '+41', nameZh: '瑞士', nameEn: 'Switzerland' },
  { code: 'SY', dialCode: '+963', nameZh: '叙利亚', nameEn: 'Syria' },
  { code: 'TJ', dialCode: '+992', nameZh: '塔吉克斯坦', nameEn: 'Tajikistan' },
  { code: 'TZ', dialCode: '+255', nameZh: '坦桑尼亚', nameEn: 'Tanzania' },
  { code: 'TL', dialCode: '+670', nameZh: '东帝汶', nameEn: 'Timor-Leste' },
  { code: 'TG', dialCode: '+228', nameZh: '多哥', nameEn: 'Togo' },
  { code: 'TO', dialCode: '+676', nameZh: '汤加', nameEn: 'Tonga' },
  { code: 'TT', dialCode: '+1868', nameZh: '特立尼达和多巴哥', nameEn: 'Trinidad and Tobago' },
  { code: 'TN', dialCode: '+216', nameZh: '突尼斯', nameEn: 'Tunisia' },
  { code: 'TR', dialCode: '+90', nameZh: '土耳其', nameEn: 'Turkey' },
  { code: 'TM', dialCode: '+993', nameZh: '土库曼斯坦', nameEn: 'Turkmenistan' },
  { code: 'TV', dialCode: '+688', nameZh: '图瓦卢', nameEn: 'Tuvalu' },
  { code: 'UG', dialCode: '+256', nameZh: '乌干达', nameEn: 'Uganda' },
  { code: 'UA', dialCode: '+380', nameZh: '乌克兰', nameEn: 'Ukraine' },
  { code: 'AE', dialCode: '+971', nameZh: '阿联酋', nameEn: 'United Arab Emirates' },
  { code: 'UY', dialCode: '+598', nameZh: '乌拉圭', nameEn: 'Uruguay' },
  { code: 'UZ', dialCode: '+998', nameZh: '乌兹别克斯坦', nameEn: 'Uzbekistan' },
  { code: 'VU', dialCode: '+678', nameZh: '瓦努阿图', nameEn: 'Vanuatu' },
  { code: 'VA', dialCode: '+379', nameZh: '梵蒂冈', nameEn: 'Vatican City' },
  { code: 'VE', dialCode: '+58', nameZh: '委内瑞拉', nameEn: 'Venezuela' },
  { code: 'YE', dialCode: '+967', nameZh: '也门', nameEn: 'Yemen' },
  { code: 'ZM', dialCode: '+260', nameZh: '赞比亚', nameEn: 'Zambia' },
  { code: 'ZW', dialCode: '+263', nameZh: '津巴布韦', nameEn: 'Zimbabwe' },
];
